module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"form-group\"> <label>Key</label> <div class=\"contained-input\"> ")
    ; __append(escapeFn( locals.api_key ))
    ; __append(" ")
    ;  if(locals.mode === 'production') { 
    ; __append(" <button class=\"show-key-btn clean-icon-btn text-blue pull-right\" type=\"button\" title=\"Hide/Show key\"> <span class=\"glyphicon ")
    ; __append(escapeFn( locals.show_production ? 'glyphicon-eye-close' : 'glyphicon-eye-open' ))
    ; __append("\"></span> </button> ")
    ;  } 
    ; __append(" <button class=\"copy-key-btn clean-icon-btn text-blue pull-right\" type=\"button\" data-clipboard-text=\"")
    ; __append(escapeFn( locals.clipboard_text ))
    ; __append("\"> <span class=\"glyphicon glyphicon-copy\"></span> </button> </div> </div> <div class=\"form-group\"> <label>Status</label> <div> <label class=\"switch\"> <input class=\"active-status-checkbox\" type=\"checkbox\" ")
    ; __append(escapeFn( locals.active ? 'checked' : '' ))
    ; __append("> <div class=\"slider round\"></div> </label> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/api_keys/list_item.ejs
// module id = 823
// module chunks = 1